import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffCompanyParameterRequest,
  StaffCompanyParameterResponse,
  StaffCompanyParametersService,
} from "lib-klab-sdks";
import { CompanyParametersPort } from "../../../app/ports/organization/company-parameters.port";
import {
  CompanyParameter,
  CompanyParameterRequest,
  LaborRegime,
} from "../../../domain/models/organization/company-parameter.model";

@Injectable({ providedIn: "root" })
export class CompanyParametersPortAdapter implements CompanyParametersPort {
  constructor(private readonly api: StaffCompanyParametersService) {}

  list(filters?: {
    laborRegime?: LaborRegime;
    digitalSignature?: boolean;
  }): Observable<CompanyParameter[]> {
    return this.api.list(filters).pipe(map((items) => items.map(mapParameter)));
  }

  getByCompanyId(companyId: number): Observable<CompanyParameter> {
    return this.api.getByCompanyId(companyId).pipe(map(mapParameter));
  }

  update(
    companyId: number,
    request: CompanyParameterRequest,
  ): Observable<CompanyParameter> {
    return this.api
      .update(companyId, request as StaffCompanyParameterRequest)
      .pipe(map(mapParameter));
  }
}

function mapParameter(item: StaffCompanyParameterResponse): CompanyParameter {
  return {
    id: item.companyParameterId,
    companyId: item.companyId,
    dailyWorkHours: item.dailyWorkHours,
    timeRegistrationFormat: item.timeRegistrationFormat,
    laborRegime: item.laborRegime,
    digitalSignatureEnabled: item.digitalSignatureEnabled,
    signatureFileName: item.signatureFileName,
    signatureContentType: item.signatureContentType,
    signatureData: item.signatureData,
  };
}
